export default {
    "name": "MergeCustomers",
    "kind": "HoudiniMutation",
    "hash": "21d14d549cad320a2097c30797dc5788766eabbab6ae02796eba5f9460adbd8e",

    "raw": `mutation MergeCustomers($input: MergeCustomersInput!) {
  mergeCustomers(input: $input) {
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "mergeCustomers": {
                "type": "Customer",
                "keyRaw": "mergeCustomers(input: $input)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "MergeCustomersInput"
        },

        "types": {
            "MergeCustomerOptionsInput": {
                "addresses": "Boolean",
                "attachments": "Boolean",
                "contacts": "Boolean",
                "messages": "Boolean",
                "options": "Boolean",
                "paymentMethods": "Boolean",
                "payments": "Boolean",
                "priceContracts": "Boolean",
                "salesOrders": "Boolean",
                "sellPriceClasses": "Boolean",
                "taxExemptions": "Boolean",
                "units": "Boolean",
                "workOrders": "Boolean"
            },

            "MergeCustomersInput": {
                "mergeOptions": "MergeCustomerOptionsInput",
                "sourceCustomerIds": "ID",
                "targetCustomerId": "ID"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=53fecd1eab87108a1607a98f00eeef7902809870cff5746712dafdb30b7cf011";